export const TOKEN_STORAGE_KEY = 'chianti_token';
export const REMENBER_PASSWORD_SWITCH_STORAGE_KEY = 'remember_password';

export const TAG_TYPE = {
  male: 'success',
  female: 'warning',
  unknown: 'info',
  init: 'info',
  completed: 'success',
  applied: 'warning',
  refunding: 'danger',
  cancelled: 'info',
  closed: 'info',
  pending: 'warning',
  shipped: '',
  received: 'success',
  draft: 'info',
  published: 'success',
  success: 'success',
  fail: 'danger',
  delay: 'pending',
  flagship_store: 'success',
  store_in_store: '',
  dealer: 'warning',
  auto: 'warning',
  business: 'success',
  rest: 'info',
}

export const PAGE_TYPE = {
  StaticPage: '静态页面',
  PresetPage: '内置页面'
}

export const PAGE_STATUS = ['draft', 'published']

export const CONTENT_TYPES = [
  'image',
  'video',
  'audio',
  'text',
  'xml',
  'json',
  'pdf',
  'sheet'
]

export const BANNER_PAGE_POSITIONS = [
  'event'
]

export const BANNER_KINDS = [
  'web_link',
  'image',
  'mp_link'
]

export const WEEKDAYS = [
  'sunday',
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday'
]

export const ACCESS_SOURCE_MAPPING_KEY = {
  1: '小程序历史列表',
  2: '搜索',
  3: '会话',
  4: '扫一扫二维码',
  5: '公众号主页',
  6: '聊天顶部',
  7: '系统桌面',
  8: '小程序主页',
  9: '附近的小程序',
  11: '模板消息',
  12: '客服消息',
  13: '公众号菜单',
  14: 'APP分享',
  15: '支付完成页',
  16: '长按识别二维码',
  17: '相册选取二维码',
  18: '公众号文章',
  19: '钱包',
  20: '卡包',
  21: '小程序内卡券',
  22: '其他小程序',
  23: '其他小程序返回',
  24: '卡券适用门店列表',
  25: '搜索框快捷入口',
  26: '小程序客服消息',
  27: '公众号下发',
  28: '系统会话菜单',
  29: '任务栏-最近使用',
  30: '长按小程序菜单圆点	',
  31: '连wifi成功页	',
  32: '城市服务',
  33: '微信广告',
  34: '其他移动应用',
  35: '发现入口-我的小程序',
  36: '任务栏-我的小程序',
  37: '微信圈子',
  38: '手机充值',
  39: 'H5',
  40: '插件',
  41: '大家在用	',
  42: '发现页	',
  43: '浮窗',
  44: '附近的人',
  45: '看一看	',
  46: '朋友圈	',
  47: '企业微信	',
  48: '视频',
  49: '收藏',
  50: '微信红包	',
  51: '微信游戏中心',
  52: '摇一摇	',
  53: '公众号导购消息',
  54: '识物',
  55: '小程序订单',
  56: '小程序直播	',
  57: '群工具',
  10: '其他 12'
}

export const ACCESS_STAYTIME_INFO_MAPPING_KEY = {
  1: '0-2s',
  2: '3-5s',
  3: '6-10s',
  4: '11-20s',
  5: '20-30s',
  6: '30-50s',
  7: '50-100s',
  8: '>100s'
}

export const ACCESS_DEPTH_INFO_MAPPING_KEY = {
  1: '1 页',
  2: '2 页',
  3: '3 页',
  4: '4 页',
  5: '5 页',
  6: '6-10 页',
  7: '>10 页'
}
